import request from '@/utils/request.js'
export const categoryList = function(data){
    return request.get('/product/category4pm',data);
}
export const ProcurementRegister = function(data){
    return request.post('/user/procurement-register',data);
}
export const RegisterCheck = function(data){  
    return request.get('/user/procurement-register-check',data);
}
export const ProcurementPause = function(data){  
    return request.post('/user/procurement-pause',data);
}



export const GetOrderList = function(data){  
    return request.get('/order-procurement/lists',data);
}
export const GetOrderCount = function(data){  
    return request.get('/order-procurement/count',data);
}
export const GetOrderDetail = function(data){  
    return request.get('/order-procurement/detail',data);
}
export const OrderAccept = function(data){  
    return request.post('/order-procurement/accept',data);
}
export const OrderReject = function(data){  
    return request.post('/order-procurement/reject',data);
}
export const OrderDelivery = function(data){  
    return request.post('/order-procurement/delivery',data);
}
export const OrderDeliverySample = function(data){  
    return request.post('/order-procurement/delivery-sample',data);
}

// 代购员-采购人员 独立沟通
export const GetProcurementChat = function(data){
    return request.post('/procurement-chat/get-or-create',data);
}
export const GetProcurementChatList = function(data){
    return request.get('/procurement-chat/list',data);
}
export const SendProcurementChat = function(data){
    return request.post('/procurement-chat/send',data);
}
export const SetProcurementChatRead = function(data){
    return request.post('/procurement-chat/set-read',data);
}
export const RecallProcurementChat = function(data){
    return request.post('/procurement-chat/recall',data);
}
export const GetProcurementChatUnread = function(){
    return request.get('/procurement-chat/unread-counts');
}
